import React from "react";
import { Card } from "@material-ui/core";
import { FormTab, TabbedForm } from "react-admin";
import { SingleCouponsTab } from "./SingleCouponsTab";
import { BatchCouponsTab } from "./BatchCouponsTab";
import { WowcherCouponsTab } from "./WowcherCouponsTab";

import "./style.css";

export const Coupons = () => {
  return (
    <Card
      component="div"
      className="tabCardWrapper creditsTabLayout user-toolbar"
      id="general-tabs-form"
    >
      <TabbedForm className="user-tabs" toolbar={<></>}>
        <FormTab label="Single Coupons">
          <SingleCouponsTab />
        </FormTab>
        <FormTab label="Batch Coupons">
          <BatchCouponsTab />
        </FormTab>
        <FormTab label="Wowcher Coupons">
          <WowcherCouponsTab />
        </FormTab>
      </TabbedForm>
    </Card>
  );
};
